export const USER_TEMPLATE_TYPE = {
  TASK: 1,
  SMS: 2,
  EMAIL: 3,
  WORKBENCH: 4,
};
